import { Consent } from '@onbeam/utils';
import { z } from 'zod';

export type ConsentOption =
  | keyof Omit<Consent, 'ad_personalization' | 'ad_storage' | 'ad_user_data'>
  | 'ad_consent';

export const consentOptions: {
  key: ConsentOption;
  isDisabled: boolean;
  value: {
    title: string;
    description: string;
  };
}[] = [
  {
    key: 'ad_consent',
    isDisabled: false,
    value: {
      title: 'cookie-modal.options.ad-consent.title',
      description: 'cookie-modal.options.ad-consent.description',
    },
  },
  {
    key: 'analytics_storage',
    isDisabled: false,
    value: {
      title: 'cookie-modal.options.analytics-storage.title',
      description: 'cookie-modal.options.analytics-storage.description',
    },
  },
  {
    key: 'functionality_storage',
    isDisabled: true,
    value: {
      title: 'cookie-modal.options.functionality-storage.title',
      description: 'cookie-modal.options.functionality-storage.description',
    },
  },
];

export const consentFormSchema = z.object({
  ad_consent: z.boolean(),
  analytics_storage: z.boolean(),
  functionality_storage: z.literal(true),
}) satisfies z.ZodObject<{
  [key in ConsentOption]: z.ZodBoolean | z.ZodLiteral<true>;
}>;

export const convertConsentToFormValues = (
  consent: Consent,
): {
  ad_consent: boolean;
  analytics_storage: boolean;
  functionality_storage: true;
} => ({
  ad_consent: consent.ad_personalization && consent.ad_storage && consent.ad_user_data,
  analytics_storage: consent.analytics_storage,
  functionality_storage: true,
});

export const DEFAULT_FORM_VALUES = {
  ad_consent: false,
  analytics_storage: false,
  functionality_storage: true,
} satisfies Record<ConsentOption, boolean>;
